<template>
  <div class="selector">
    <div class="header">
      <div class="title">管线养护</div>
    </div>

    <div class="query">
        <div class="queryInfo">
          <InputField labelWidth="0" style="margin: 0.5rem 0.5rem;width:20%;" type="text" id="code" v-model="queryForm.name" placeholder="养护计划名称"/>
            <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;" :options="typeList" v-model="queryForm.type" id="type" placeholder="养护计划类型"/>
            <RangePickerField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;" v-model="queryForm.date" :placeholder="['开始时间', '结束时间']" :disabled="false"/>
            <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;" :options="statusList" v-model="queryForm.status" id="status" placeholder="养护状态"/>
          <a-space>
              <ButtonField text="查询" @click="query" secondary />
              <ButtonField text="重置" primary @click="reset"/>
          </a-space>
        </div>
        <div>
            <ButtonField text="创建养护计划" @click="add" secondary />
        </div>
    </div>

    <div class="table">
        <Tablelist
                style="margin-top: 1rem"
                :showCheckbox="false"
                :list="list"
                :columns="tableColumns"
                @action="handleAction"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a-space>
                        <a href="#" @click.prevent="editText(item)">编辑</a>
                        <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                    </a-space>
                </a-space>
            </template>
        </Tablelist>

    </div>
      <Modal v-if="visible" v-model="visible"
             :visible="visible"
             title="创建养护计划"
             :showFooter="false"
             :overlayOpacity="0.5"
             contentWidth="30%"
             @update:visible="visible = $event">
          <form @submit.prevent="handleSubmit">
              <div style="width: 90%;margin: auto;">
                <div class="form-group-list">
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;" label="计划名称" type="text" id="name" v-model="form.name" required placeholder="计划名称"/>
                    <SelectField labelWidth="32%" style="margin: 0.5rem 0.2rem;"  label="计划类型" required :options="typeList" v-model="queryForm.type" id="type" placeholder="计划类型"/>
                </div>
                <div class="form-group-list">
                    <RangePickerField labelWidth="30%" label="开始截至日期" v-model="form.date" required :placeholder="['开始时间', '结束时间']" :disabled="false"/>
                    <InputField labelWidth="30%" style="margin: 0.5rem 0.2rem;" label="位置" type="text" id="location" v-model="form.location" required placeholder="位置"/>
                </div>
                <div class="form-group-list">
                    <TextareaField :value="form.remarks" required labelWidth="30%" style="margin: 0.5rem 0.2rem" label="计划详情"/>
                    <SelectField labelWidth="32%" style="margin: 0.5rem 0.2rem;"  label="养护状态" required :options="statusList" v-model="form.status" id="type" placeholder="养护状态"/>
                </div>
                <div class="right" style="margin: 1rem 0 0 0;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
              </div>
          </form>
      </Modal>

  </div>
</template>

<script>
import Modal from "@/components/water-affairs-style/modal.vue";
export default {
  components: {Modal},
  data() {
    return {
      queryForm: {},
      loading: false,
      current: 1,
      pageSize: 10,
      typeList:[{value:'1',name:'仪表矫正'}],
      statusList:[{value:1,name:'待养护'},{value:2,name:'养护中'},{value:3,name:'养护完成'}],
      list: [
        {
          name: "日常养护",
          type: "仪表校正",
          location: "厂区",
          date: "2022/06/22-2022-06-23",
          remarks: "--",
          status: "进行中",
        },
        {
          name: "日常养护",
          type: "仪表校正",
          location: "厂区",
          date: "2022/06/22-2022-06-23",
          remarks: "--",
          status: "进行中",
        },
      ],
      total: 0,
      form: this.$form.createForm(this),
      visible: false,
      tableColumns:[
          {
            key: 'name',
            title: '养护计划名称',
            field: 'name',
            infotype: 'text'
        },
            {
                key: 'type',
                title: '养护计划类型',
                field: 'type',
                infotype: 'text',
            },
            {
                key: 'location',
                title: '位置',
                field: 'location',
                infotype: 'text',
            },
            {
                key: 'date',
                title: '开始截至日期',
                field: 'date',
                infotype: 'text',
            },
            {
                key: 'remarks',
                title: '计划详情',
                field: 'remarks',
                infotype: 'text',
            },
            {
                key: 'status',
                title: '养护状态',
                field: 'status',
                infotype: 'text',
            },
            {
                key: 'actions',
                title: '操作',
                infotype: 'template',
            }],
    };
  },

  methods: {
    query() {},
    reset() {
      this.queryForm = {};
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
    },
    editText(item) {
        this.visible = true;
        this.form = item
    },
    deleteText() {

    },

    add() {
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("values", values);
          this.cancel();
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.selector {
  position: fixed;
  top: 11vh;
  left: 17vw;
  right: calc(1vw + 140px);
  z-index: 99;
  background-color: var(--default-bgcolor);

  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #065645;
  & > .header {
    background-color:rgba(0, 0, 0, 0.9);
    color: #00ff96;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0 0.5rem 1rem;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1rem;
  }

  .query {
    padding: 2vh 1vw 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .table {
    padding: 2vh 1vw;
  }
  .queryInfo{
    display: flex;
    justify-content: space-around;
  }
}
</style>